document.addEventListener('DOMContentLoaded', function () {
  const host = window.location.host;
  const path = window.location.pathname;

  // Kør KUN på .eu domænet – og IKKE hvis URL'en indeholder /en-eu
  if (!host.endsWith('clubcollection.eu')) return;
  if (path.includes('/en-eu')) return;

  // Liste af alle tekst-udskiftninger
  const replacements = [
    { from: 'Fri fragt over 900 kr. | Gratis retur | Julens åbningstider: Mandag - fredag 10-17:30. Lørdag & Søndag 10-14.', to: 'FREE DELIVERY FROM 164 EURO | DELIVERY WITHIN EU' },
    { from: 'Fri fragt over 900 DKK', to: 'Free shipping over 900 DKK' },
    { from: 'Hurtig levering', to: 'Fast shipping' },
    { from: 'Gratis retur', to: 'Free returns' },
    { from: 'E-mærket webshop', to: 'E-branded webshop' },
    { from: 'Åbningstider:', to: 'Opening hours:' },
    { from: 'Mandag - fredag 10 - 17:30. Lørdag 10-14.', to: 'Monday - friday 10 - 17:30. Saturday 10-14.' },
    { from: 'Lukket på helligdage.', to: 'Closed on holidays.' },
    { from: 'Tilmeld dig vores nyhedsbrev', to: 'Join our newsletter' },
    { from: 'Din email', to: 'Your e-mail' },
    { from: 'Tilmeld', to: 'Join' },
    { from: 'KUNDESERVICE', to: 'CUSTOMER SERVICE' },
    { from: 'OM OS', to: 'ABOUT US' },
    { from: 'FØLG OS', to: 'FOLLOW US' },
    { from: 'Andre købte også', to: 'Others also bought' },
    { from: 'Sådan! Du har opnået gratis fragt', to: 'Congrats! You get free shipping' },
    { from: 'Shop herre', to: 'Shop men' },
    { from: 'Kontakt os', to: 'Contact us' },
    { from: 'Materialer', to: 'Materials' },
    { from: 'Vores', to: 'Our' },
    { from: 'Historie', to: 'History' },
    { from: 'Lun strik til de små', to: 'Cozy knitwear for the little ones' },
    { from: 'Alt i cashmere', to: 'All our cashmere' },
    { from: 'Andre materialer', to: 'Other material' },
    { from: 'ANDET', to: 'Other' }
  ];

  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  let node;
  while ((node = walker.nextNode())) {
    replacements.forEach(pair => {
      if (node.nodeValue.includes(pair.from)) {
        node.nodeValue = node.nodeValue.replace(pair.from, pair.to);
      }
    });
  }
});

// Fjern "Shipping & Returns" fra menu på EU-siden
document.querySelectorAll('a').forEach(link => {
  if (link.textContent.trim() === 'Shipping & Returns') {
    link.closest('li')?.remove();
  }
});
